// opervex-frontend/src/Opervex/HumanResources/Integrations.js

class Integrations {
  #_api;

  constructor(api) {
    this.#_api = api;
  }

  // Synchronize
  async synchronize(data) {
    return this.#_api.post("/HumanResources/Integrations/Synchronize", data);
  }
}

export default Integrations;
